/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown>, message: NonNullable<unknown> }} Updates_Downloadingupdate1Inputs */

const tr_updates_downloadingupdate1 = /** @type {(inputs: Updates_Downloadingupdate1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Güncelleme indiriliyor: %${i?.progress} (${i?.message})`)
};

const en_updates_downloadingupdate1 = /** @type {(inputs: Updates_Downloadingupdate1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Downloading update: %${i?.progress} (${i?.message})`)
};

/**
* | output |
* | --- |
* | "Downloading update: %{progress} ({message})" |
*
* @param {Updates_Downloadingupdate1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_downloadingupdate1 = /** @type {((inputs: Updates_Downloadingupdate1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Downloadingupdate1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_downloadingupdate1(inputs)
	return en_updates_downloadingupdate1(inputs)
});
export { updates_downloadingupdate1 as "updates_downloadingUpdate" }